import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-text-area-with-copy',
  templateUrl: './text-area-with-copy.component.html',
  styleUrls: ['./text-area-with-copy.component.scss'],
})
export class TextAreaWithCopy {
  @Input() copyLabel: string = 'copy';
  @Input() isRequired: boolean = false;
  @Input() editableTextLabel!: string;
  @Input() editableTextFormControl!: any;
  @Input() editableTextMaxLength: number = 1000;
  @Input() textAreaHeight: string = '100px';
  @Input() showCopyLabel: boolean = false;
  @Input() id!: string;
  @Input() name!: string;
  @Input() counter?: number = 0;
  @Output() copyEvent: EventEmitter<void> = new EventEmitter();

  updateCounter(newLength: number) {
    this.counter = newLength;
  }
}